import React from "react";
import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import dynamic from "next/dynamic";

import { Button } from "@/components/index";

import { ShareActions } from "@/shared/utils/share/share";
import { systemActions } from "@/store/actions";
import { GoogleTranslateIcon } from "../../../assets/CommonIcons";
import EgwWebFont from "../../../assets/EgwWebFont";
import IconButton from "@/shared/components/IconButton/IconButton";
import { removeTags } from "@/shared/utils/content/content";

import styles from "./share-popup.module.scss";

const DropDown = dynamic(() => import("@/shared/components/DropDown/DropDown"), {
  ssr: false,
});

const SharePopup = ({ renderButton, url, refCode, text, title }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <DropDown
      button={(btnProps) => {
        const { show, onClick } = btnProps;

        return typeof renderButton === "function" ? (
          renderButton(btnProps)
        ) : (
          <IconButton
            active={show}
            icon={EgwWebFont.share}
            onClick={onClick}
            title={t("shareText")}
          />
        );
      }}
      body={({ hide }) => {
        return (
          <div className={styles["share-body"]}>
            {ShareActions.map(
              ({ icon, title: btnTitle, service, action, shareViaHtmlAttrs, justCopy }, index) => {
                if (shareViaHtmlAttrs) {
                  return (
                    <a key={index} tabIndex={0} data-service={service} data-url={url} href="#">
                      <Button onClick={hide}>
                        <GoogleTranslateIcon title={title} />
                      </Button>
                    </a>
                  );
                }
                let iconView;
                if (typeof icon === "number") {
                  iconView = (
                    <i title={btnTitle} className={"egw-font-icon"}>
                      {String.fromCodePoint(icon)}
                    </i>
                  );
                } else {
                  const Tag = icon;
                  iconView = <Tag title={btnTitle} />;
                }

                return (
                  <Button
                    tabIndex={0}
                    key={index}
                    onClick={(e) => {
                      if (action) {
                        action({ url, title, refcode: refCode, text: removeTags(text) });
                      } else if (justCopy) {
                        dispatch(
                          systemActions.actionCopy(url, {
                            successMessage: t("linkCopied"),
                            errorMessage: t("linkNotCopied"),
                          }),
                        );
                      }

                      hide(e);
                    }}
                    data-service={service}
                    data-url={url}>
                    {iconView}
                  </Button>
                );
              },
            )}
          </div>
        );
      }}
    />
  );
};

SharePopup.propTypes = {
  renderButton: PropTypes.func,
  refCode: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  url: PropTypes.string,
};

export default SharePopup;
